<template>
  <div class="row">
    <div class="col-md-10 pt-3" v-if="hasAnyRole('ROLE_ATMANAGE')">

      <toast ref="toast"></toast>

      <table class="table table-bordered table-responsive">
            <thead class="thead-light">
              <tr>
                  <th>No</th>
                  <th>会社名</th>
                  <th>ドメイン</th>
                  <th>対象年月</th>
                  <th>今月契約数</th>
                  <th>プラン</th>
                  <th>請求（とりあえず100円計算）</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(result, index) in reportList" :key="index">
                  <td>{{(pagination.currentPage * dispMaxSize) + index + 1}}</td>
                  <td class="noflap">
                     <span class="noflap">
                          {{result.companyName}}
                     </span>
                  </td>
                  <td class="noflap">{{result.domain}}</td>
                  <td>{{result.year}}年{{result.month}}月</td>
                  <td style="text-align:right;">{{result.userCount}}</td>
                  <td>{{result.plan == 0 ? 'ノーマル' : 'エラー'}}</td>
                  <td>{{result.userCount * 100 | yen }}円</td>
              </tr>
            </tbody>
        </table>
    </div>
  </div>
</template>

<style scoped>
.noflap{
 white-space: nowrap;
}
.retiree{
  background: #ccc !important;
}
.icon {
  border-radius: 50%;
  height: 45px;
  width: 45px;
}
.modal {
  overflow-y: auto;
  max-height: 95%;
}
</style>

<script>
import CompanyAPI from '../../../api/company-api'
import CommonAPI from '../../../api/common-api'
import Toast from '../../Toast.vue'
import moment from 'moment'

export default {
  name: "company-report-list",
  components: {
    Toast,
  },
  data() {
    return {
      reportList: [],
      loginUser: {
        role: ''
      },
      dispMaxSize: 20,
      pagination: {
        // 現在ページ
        currentPage: 0,
        // 最大表示ページ件数
        dispMaxPageSize: 5,
        // トータルページ数
        totalPages: 0
      }
    }
  },
  watch: {
    '$root.$refs.asnHeader.$data.loginUser': function (val) {
      this.loginUser = this.$root.$refs.asnHeader.$data.loginUser
      if(this.hasAnyRole('ROLE_ATMANAGE')){
          this.getCompanyReportList()
      }
    },
  },
  mounted () {
  },
  methods: {
    getCompanyReportList() {
      this.$root.$refs.loading.$data.show = true
      let params = {}
      params['pageSize'] = this.dispMaxSize
      params['pageNo'] = this.pagination.currentPage ? this.pagination.currentPage : 0
      CompanyAPI.report(this.$route.params.companyId, params)
          .then(res => {
            if (res.content){
              this.pagination.totalPages = res.totalPages
              this.reportList = res.content             
            } else {
              this.pagination.totalPages = 0
              this.pagination.currentPage = 0
              this.reportList = []
            }
            this.$root.$refs.loading.$data.show = false
          })
          .catch(err => {
            console.error(err)
            this.$root.$refs.loading.$data.show = false
          })
    },
    // 権限を持っているか判定
    hasAnyRole: function (...args) {
        for (var i = 0; i < arguments.length; i++) {
            if (this.loginUser && this.loginUser.role.includes(arguments[i])) {
                return true
            }
        }
        return false
    },
   },
  filters: {
    date: function (data) {
      return data ? moment(data).format("YYYY年MM月DD日") : ''
    },
    between: function (data) {
      return data ? moment().to(moment(data)) : ''
    },
    yen: function (data) {
      return data.toLocaleString()
    },
  }
}
</script>


// WEBPACK FOOTER //
// src/assets/js/components/atmanage/company/CompanyReportList.vue